import { render } from "./TestForm.vue?vue&type=template&id=0fdaa63f&scoped=true"
import script from "./TestForm.vue?vue&type=script&lang=js"
export * from "./TestForm.vue?vue&type=script&lang=js"

import "./TestForm.vue?vue&type=style&index=0&id=0fdaa63f&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdaa63f"]])

export default __exports__